<template>
  <div class="PayTypeAmount pointer">
    <div class="typeAmount-item">
      <div class="item" v-if="isStepper">
        <div class="item_left">
          <p class="p1">购买数量</p>
        </div>
        <div class="item_right">
          <van-stepper
            :max="combo.limitCount"
            :min="combo.overallMminCount < 1 ? 1 : combo.overallMminCount"
            v-model="count"
            @change="handleChange"
            input-width="50"
          />
        </div>
      </div>
      <div class="item" v-if="renewIdList.length > 0">
        <div class="item_left">
          <p class="p1">续费数量</p>
        </div>
        <div class="item_right">
          {{ renewIdList.length }}
        </div>
      </div>
      <div class="item" @click="payTypeShow = true">
        <div class="item_left">
          <p class="p1">支付方式</p>
        </div>
        <div class="item_right">
          <div class="payTypeName">
            <img class="icon" :src="getPayTypeItem(payType).icon" alt="" />
            <div class="label">{{ getPayTypeItem(payType).label }}支付</div>
            <img
              class="arrows-rigth"
              src="@/assets/icons/arrows-rigth.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    <van-action-sheet class="payTypePopup pcPopup" v-model="payTypeShow">
      <div class="content">
        <div class="titleBox">
          <div class="titleName">支付方式</div>
          <div class="close" @click="payTypeShow = false">
            <img src="@/assets/icons/popupClose.png" alt="" />
          </div>
        </div>
        <van-radio-group v-model="payTypeRadio" class="radioGroup">
          <div
            class="radio"
            v-for="item in payTypeOptions"
            :key="item.value"
            @click="handlePayTypeChange(item.value)"
          >
            <div class="radio_left">
              <img class="icon" :src="item.icon" alt="" />
              <div class="label">{{ item.label }}支付</div>
            </div>
            <van-radio :name="item.value" checked-color="#8572eb" />
          </div>
        </van-radio-group>
      </div>
    </van-action-sheet>
  </div>
</template>
          <script>
export default {
  name: "PayTypeAmount",
  model: {
    prop: "count",
    event: "change",
  },
  props: {
    count: {
      type: Number,
      default: 1,
    },
    payType: {
      type: Number,
      default: 5,
    },
    isStepper: {
      type: Boolean,
      default: false,
    },
    combo: {
      default: () => ({ limitCount: 1 }),
      type: Object,
    },
    renewIdList: {
      default: () => [],
      type: Array,
    },
  },
  watch: {
    // count: {
    //   handler(newVal, oldVal) {
    //     console.log(count);
    //     this.stepperval = newVal;
    //   },
    //   deep: true,
    // },
    payType: {
      handler(newVal, oldVal) {
        this.payTypeRadio = newVal;
      },
      deep: true,
    },
  },
  data() {
    return {
      stepperval: 1,
      payTypeOptions: [
        {
          label: "微信",
          icon: require("@/assets/icons/wx.png"),
          value: 5,
        },
        {
          label: "支付宝",
          icon: require("@/assets/icons/zfb.png"),
          value: 6,
        },
      ],
      payTypeShow: false,
      payTypeRadio: 5,
    };
  },
  mounted() {},
  computed: {
    getPayTypeItem: {
      get() {
        return function (status) {
          let item = this.payTypeOptions.find((item) => item.value == status);
          if (item) {
            return item;
          }
        };
      },
    },
  },
  methods: {
    handleChange() {
      this.$emit("update:count", this.count);
      this.$emit("handleChange", this.count);
    },
    handlePayTypeChange(value) {
      this.payTypeShow = false;
      this.payTypeRadio = value;
      this.$emit("handlePayTypeChange", this.payTypeRadio);
    },
  },
};
</script>
          
      <style lang="less" scoped>
.PayTypeAmount {
  .typeAmount-item {
    width: 100%;
    background: #fff;
    border-radius: 10px;
    color: #333;
    font-size: 14px;
    padding: 0 17px;
    .item {
      width: 100%;
      height: 58px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .item_left {
        display: flex;
        align-items: center;
        .p1 {
          font-weight: 500;
          font-size: 15px;
          color: #505465;
        }
        .ico {
          width: 16px;
          height: 16px;
          margin-right: 12px;
        }
      }
      .item_right {
        .payTypeName {
          display: flex;
          align-items: center;
          font-size: 15px;
          color: #505465;
          .icon {
            width: 19px;
            height: 19px;
          }
          .label {
            margin: 0 8px;
          }
          .arrows-rigth {
            width: 15px;
            height: 15px;
          }
        }
      }
    }
    .item:not(:last-child) {
      border-bottom: 1px solid #f5f7fb;
    }
  }
}
/deep/.van-stepper__plus {
  background-color: #886df3;
  border-radius: 2px;
  color: #fff;
}
/deep/.van-stepper__plus::before {
  height: 3px;
}
/deep/.van-stepper__plus::after {
  width: 3px;
}
/deep/.van-stepper__minus {
  background-color: #c4c7d0;
  border-radius: 2px;
  color: #fff;
}
/deep/.van-stepper__minus::before {
  height: 3px;
}
.payTypePopup {
  background: #f4f6fa;
  .content {
    padding: 25px 0 21px 0;
    .titleBox {
      display: flex;
      justify-content: center;
      position: relative;
      .titleName {
        font-weight: 600;
        font-size: 17px;
        color: #222222;
      }
      .close {
        width: 25px;
        height: 25px;
        position: absolute;
        right: 21px;
        top: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 17px;
          height: 17px;
        }
      }
    }
    .radioGroup {
      margin-top: 15px;
      .radio {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        padding: 16px 21px;

        .radio_left {
          display: flex;
          .icon {
            width: 25px;
            height: 25px;
          }
          .label {
            font-weight: 500;
            font-size: 15px;
            color: #505465;
            margin-left: 8px;
          }
        }
      }
    }
  }
}
</style>